






















import { Component, Prop, Vue } from 'vue-property-decorator';
import SelectFacility from '@/components/SelectFacility.vue';
import FacilityPreview from '@/components/FacilityPreview.vue';
import { Facility } from '@/models/facility';
import SessionManager from '@/helpers/session-manager';
import { EventBus } from '@/event-bus';
import { SurveyElementsUnion } from '@/models/survey-elements-union';
import { WIDGET_EVENTS } from '@/const/widget-events';

@Component({
  name: 'select-facility-element-widget',
  components: {
    SelectFacility,
    FacilityPreview,
  },
})
export default class SelectFacilityElementWidget extends Vue {
  @Prop({ type: String }) title?: string;
  @Prop({ type: String, required: true }) cityLabel!: string;
  @Prop({ type: String, required: true }) cityPlaceholder!: string;
  @Prop({ type: String, required: true }) facilityLabel!: string;
  @Prop({ type: String, required: true })
  facilityPlaceholder!: string;
  @Prop({ type: String, required: true }) selectedFacilityLabel!: string;
  @Prop({ type: String, required: true }) changeFacilityButtonText!: string;
  @Prop({ type: Object }) field?: SurveyElementsUnion;
  @Prop({ type: String, required: true }) elementType!: string;

  private isEditMode: boolean = false;

  private get defaultFacility(): Facility {
    return this.$store.state.defaultFacility;
  }

  private get isPreselectedFacility(): boolean {
    return (
      !!this.$route.params.type &&
      !!this.$route.params.id &&
      !!this.defaultFacility
    );
  }

  private setEditMode(value: boolean) {
    this.isEditMode = value;
    this.returnToDefaultUrl();
    EventBus.$emit(WIDGET_EVENTS.CHANGE, { field: this.field, value: null });
  }

  private returnToDefaultUrl() {
    const params = this.$route.params;

    delete params.type;
    delete params.id;
    SessionManager.deleteSession();
    this.$router.replace({
      params,
    });
  }

  private onFacilityChange(facility: Facility) {
    this.$store.dispatch('setDefaultFacility', facility);
    EventBus.$emit(WIDGET_EVENTS.CHANGE, {
      field: this.field,
      value: facility?.id || null,
    });
  }
}
